<template>
  <div class="sfboxl2">
    <div class="wfull">
        <div class="hotfbox">
            <div id="contentbox" class="after-sales-wfull-left">
                <div class="aswl-tech">
                    <span>售后服务</span>
                </div>
                <div class="aswl-tech-cont">
                    <div class="aswl-tech-cont-box">
                        <img src="../../static/img/shouhou.png" />
                        <div class="aswl-tech-cont-box-div">
                            <span class="iconfontyyy ydy">
                                <img src="../../static/img/ren.png" alt="">
                            </span>
                            <div>
                                <h2>1对1专属顾问及时回复</h2>
                                <p>1对1技术支持</p>
                                <p>强大的服务团队</p>
                                <p>QQ：309816335 </p>
                                <p>微信：haochihaohe2012 </p>
                                <p>传真：021-39927292 </p>
                                <p>邮箱：cxg@qikesh.com‍</p>
                                <p>时间：周一到周五 09：00-18：00(法定节假日除外)</p>
                            </div>
                        </div>
                    </div>
                </div>
              
            </div>
        </div>
    </div>
    <div class="clear"></div>
</div>
</template>

<script>
export default {
  name: 'hello',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 p{
    text-indent:2em;
  }
</style>



// WEBPACK FOOTER //
// Contact.vue?058d9caa